import { GeneratedSignerSettingsIdentity } from '../generated/domain-models/generated-signer-settings.identity';

export class SignerSettingsIdentity extends GeneratedSignerSettingsIdentity {

}
